import { AssignedProjectCoreBase } from "./assigned-project.core.base"


export class AssignedProjectCore extends AssignedProjectCoreBase {

}